<!-- begin:: Page -->
<template>
  <div
    class="m-grid m-grid--hor m-grid--root m-page"
    style="height: 100%"
  >
    <div
      id="m_login"
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
    >
      <div
        class=" b m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center"
        :style="'background: url('+cdnURL+'/img/bg/bg-login.jpg) no-repeat center center / COVER'"
      >
        <div
          id="login-form-container"
          class="m-grid__item text-center p-4"
        >
          <button
            v-if="view === 'change_password'"
            type="button"
            class="btn btn-link p-0 d-block"
            @click="abandonPasswordChange"
          >
            <img
              alt="thinkSPAIN"
              :src="cdnURL+'/img/logos/white.png'"
              width="250px"
            >
            <p class="m-login__msg mb-2">
              {{ $t('app.name') }}
            </p>
          </button>
          <div v-else>
            <img
              alt="thinkSPAIN"
              :src="cdnURL+'/img/logos/white.png'"
              width="250px"
            >
            <p class="m-login__msg mb-2">
              {{ $t('app.name') }}
            </p>
          </div>
          <div
            id="language-picker"
            class="p-2"
          >
            <button
              type="button"
              :class="{'btn p-0 d-flex mr-2':true,'active':isActiveLanguage('en')}"
              :title="$t('lang.en')"
              @click="setLocale('en')"
            >
              {{ $t('lang.en') }}
            </button>
            <button
              type="button"
              :class="{'btn p-0 d-flex':true,'active':isActiveLanguage('es')}"
              :title="$t('lang.es')"
              @click="setLocale('es')"
            >
              {{ $t('lang.es') }}
            </button>
          </div>
          <form
            v-if="view === 'login'"
            class="m-login__form m-form"
            style="width: 400px; max-width: 100%;"
            @submit.prevent="doLogin"
          >
            <div class="form-group m-form__group mt-3">
              <input
                v-model="login"
                class="form-control m-input"
                type="text"
                :placeholder="$t('Login.login')"
                autocomplete="off"
                required
              >
            </div>
            <div class="form-group m-form__group mt-0 pt-0">
              <input
                v-model="password"
                class="form-control m-input m-login__form-input--last"
                :type="passwordInputType"
                :placeholder="$t('Login.password')"
                autocomplete="off"
                required
              >
              <button
                v-if="password && password.length > 0"
                id="btn-password-toggle"
                class="btn btn-link p-0 text-white text-decoration-none d-flex align-items-center mt-1"
                type="button"
                @click="togglePassword"
              >
                <template v-if="passwordInputType === 'password'">
                  <i class="la la-eye mr-2" />
                  {{ $t( 'Login.showPassword' ) }}
                </template>
                <template v-else>
                  <i class="la la-eye-slash mr-2" />
                  {{ $t( 'Login.hidePassword' ) }}
                </template>
              </button>
            </div>
            <div class="m-login__form-action">
              <button
                id="m_login_signin_submit"
                type="submit"
                class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air w-100 font-weight-bold"
                :disabled="loading"
              >
                {{ $t('Login.signinbtn') }}
              </button>
            </div>
            <router-link
              to="/reset-password"
              class="btn btn-link mt-2 font-weight-bold text-white"
            >
              {{ $t('Login.forgotPassword') }}
            </router-link>
            <p
              id="forgot-details-text"
              class="mb-0 mt-4 text-white"
              v-html="$t( 'Login.forgotClientID' )"
            />
          </form>
          <form
            v-else-if="view === 'change_password'"
            class="m-login__form m-form"
            style="width: 400px; max-width: 100%;"
            @submit.prevent="changePassword"
          >
            <div :class="{'form-group m-form__group pb-0 mt-3': true, 'has-success': hasClientID}">
              <input
                v-model="login"
                class="form-control m-input"
                type="text"
                :placeholder="$t('Login.login')"
                autocomplete="off"
                required
                :disabled="loading"
              >
            </div>
            <div :class="{'form-group m-form__group mt-3 pt-0': true, 'has-success': passwordIsOK, 'has-error': hasProvidedPassword && !passwordsMatch}">
              <input
                v-model="password"
                class="form-control m-input m-login__form-input--last"
                :type="passwordInputType"
                :placeholder="$t('Login.password')"
                autocomplete="off"
                required
                :disabled="loading"
              >
              <input
                v-model="passwordConfirmed"
                class="form-control m-input m-login__form-input--last mt-3"
                :type="passwordInputType"
                :placeholder="$t('Login.confirmPassword')"
                autocomplete="off"
                required
                :disabled="loading"
              >
              <p
                v-if="hasProvidedPassword && !passwordsMatch"
                class="text-white font-weight-bold mt-1 mb-0 text-left"
              >
                {{ $t( 'error.server.ErrPasswordsDontMatch' ) }}
              </p>
              <p
                v-if="hasProvidedPassword && !passwordMeetsRequirements"
                class="text-white font-weight-bold mt-1 mb-0 text-left"
              >
                {{ $t( 'error.server.ErrPasswordDoesNotMeetRequirements' ) }}
              </p>
              <button
                v-if="hasProvidedPassword"
                id="btn-password-toggle"
                class="btn btn-link p-0 text-white text-decoration-none d-flex align-items-center mt-1"
                type="button"
                @click="togglePassword"
              >
                <template v-if="passwordInputType === 'password'">
                  <i class="la la-eye mr-2" />
                  {{ $t( 'Login.showPassword' ) }}
                </template>
                <template v-else>
                  <i class="la la-eye-slash mr-2" />
                  {{ $t( 'Login.hidePassword' ) }}
                </template>
              </button>
            </div>
            <div class="m-login__form-action">
              <button
                id="m_login_signin_submit"
                type="submit"
                class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air w-100 font-weight-bold"
                :disabled="loading || !canSubmitPasswordChange"
              >
                {{ $t('Login.changePassword') }}
              </button>
              <button
                type="button"
                class="btn btn-link mt-2 font-weight-bold text-white text-decoration-none"
                @click="abandonPasswordChange"
              >
                <i class="la la-chevron-left" />
                {{ $t('Login.backToLogin') }}
              </button>
            </div>
          </form>
        </div>
        <div
          v-if="!cookieAccepted"
          role="alert"
          class="m-alert m-alert--icon m-alert--air m-alert--square alert alert-dismissible fade show cookie-consent"
        >
          <div class="m-alert__icon">
            <i class="flaticon-exclamation-1" />
            <span />
          </div>
          <div class="m-alert__text text-center">
            <span class="cookie-consent--span">
              <strong>{{ $t('common.COOKIES') }}:</strong> {{ $t('common.CookiesConsent') }}.
            </span>
            <button
              type="button"
              data-dismiss="alert"
              aria-label="Close"
              class="d-inline btn btn-sm btn-primary btn-sm-block cookie-consent--button"
              @click="acceptCookieConsent(true)"
            >
              {{ $t('common.ok') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { checkIfEmail, getUserFromToken, onBeforeOpenSwal } from '../../functions.ts';
import authapi from '../../api-clients/auth-api.js';
import  { adminauthapiwithoutrefresh } from '../../api-clients/admin-auth-api.js';
import Cookie from 'js-cookie';
import { validatePassword } from '../../common/auth.js';
import { getRedirectPathFromRoute } from '../../router.js';

export default {
    name: 'Login',
    data() {
        return {
            cookieAccepted: false,
            cdnURL: import.meta.env.TWC_CDN_URL,
            login: '',
            email: '',
            password: '',
            passwordConfirmed: '',
            passwordInputType: 'password',
            view: 'login',
            loading: false,
        };
    },
    computed: {
        hasClientID() {
            return !!this.login;
        },
        passwordsMatch() {
            return this.hasProvidedPassword && this.password === this.passwordConfirmed;
        },
        hasProvidedPassword() {
            return !!this.password || !!this.passwordConfirmed;
        },
        passwordMeetsRequirements() {
            return this.hasProvidedPassword && this.passwordsMatch && validatePassword( this.password );
        },
        passwordIsOK() {
            return this.hasProvidedPassword && this.passwordsMatch && this.passwordMeetsRequirements;
        },
        canSubmitPasswordChange() {
            return this.hasClientID && this.passwordIsOK;
        },
    },
    created() {
        $( '.loading' ).fadeOut();

        if ( Cookie.get( 'access_token' ) ) {
            const toUrl = this.$route.query.redirect ? this.$route.query.redirect : '/dashboard';
            this.$router.replace( toUrl ).then( ( res ) => {} ).catch( ( res ) => {} );
        }
    },
    async mounted() {
        if ( Cookie.get( 'cookie_consent' ) ) {
            this.cookieAccepted = true;
        }

        const clientID = this.$route.query.clientID;

        if ( clientID && clientID.length > 0 ) {
            this.login = this.$route.query.clientID;

            const r = await authapi.post( '/client/auth/status', {
                clientID: this.$route.query.clientID,
                email: this.$route.query.email,
            } );

            if ( r.status === 200 && r.data.status === 'requires_password_change' ) {
                this.view = 'change_password';
            } else {
                this.view = 'login';

                this.$router.replace( {
                    path: '/',
                } );
            }
        }

        this.$utils.fadeOutLoading();
    },
    methods: {
        togglePassword() {
            if ( this.passwordInputType === 'text' ) {
                this.passwordInputType = 'password';
            } else {
                this.passwordInputType = 'text';
            }
        },
        setLocale( locale ) {
            Cookie.set( 'locale', locale, { expires: 14,
                sameSite: 'Strict' } );
            this.$i18n.locale = locale;
        },
        isActiveLanguage( codeLang ) {
            return this.$i18n.locale === codeLang;
        },
        abandonPasswordChange() {
            this.password = '';
            this.passwordConfirmed = '';
            this.view = 'login';
        },
        async changePassword() {
            if ( !this.canSubmitPasswordChange ) {
                return;
            }

            this.loading = true;

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const res = await authapi.post( '/client/auth/reset', {
                clientID: this.login,
                password: this.password,
            } );

            if ( res.status !== 200 ) {
                mApp.unblock( 'body' );
                this.loading = false;

                swal( {
                    title: '',
                    text: this.$t( 'Login.resetFailed' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            swal.fire( {
                title: '',
                text: this.$t( 'Login.resetPasswordSuccessMsg' ),
                type: 'success',
                confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                onBeforeOpen: () => {
                    onBeforeOpenSwal();
                },
            } ).then( async () => {
                this.$router.replace( {
                    path: '/',
                } );

                await this.loginUser();
            } );

            mApp.unblock( 'body' );

            this.loading = false;
        },
        async loginUser() {
            const res = await authapi.post( '/client/auth', { login: this.login,
                password: this.password } );

            if ( res.status === 403 && res.data.code === 'ErrPasswordChangeRequired' ) {
                this.password = '';
                this.passwordConfirmed = '';
                this.view = 'change_password';
                return;
            }

            if ( res.status !== 200 ) {
                swal( {
                    title: '',
                    text: this.$t( 'Login.loginFailed' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            Cookie.set( 'access_token', res.data.accessToken, { expires: 3,
                sameSite: 'Strict' } );
            Cookie.set( 'refresh_token', res.data.refreshToken, { expires: 3,
                sameSite: 'Strict' } );

            let clientURL = '/dashboard';

            const redirectPath = getRedirectPathFromRoute( this.$route );

            if ( redirectPath ) {
                clientURL = redirectPath;
            }

            await this.$router.replace( clientURL );

            const user = getUserFromToken( res.data.accessToken );

            toastr.success( this.$t( 'Dashboard.welcomeMsg', { userName: user.TradeName || user.CompanyName } ) );
        },
        async loginAdmin() {
            let res = await adminauthapiwithoutrefresh.post( '/internal/auth', { email: this.login,
                password: this.password } );

            if ( res.status !== 200 ) {
                swal( {
                    title: '',
                    text: this.$t( 'Login.loginFailed' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            Cookie.set( 'admin_access_token', res.data.accessToken, { expires: 3,
                sameSite: 'Strict' } );
            Cookie.set( 'admin_refresh_token', res.data.refreshToken, { expires: 3,
                sameSite: 'Strict' } );

            let adminURL = '/admin';

            const redirectPath = getRedirectPathFromRoute( this.$route );

            if ( redirectPath ) {
                adminURL += `?redirect=${encodeURIComponent( redirectPath )}`;
            }

            await this.$router.replace( adminURL );

            const user = getUserFromToken( res.data.accessToken );

            toastr.success( this.$t( 'Dashboard.welcomeMsg', { userName: user.Name } ) );
            return;
        },
        async doLogin() {
            if ( checkIfEmail( this.login ) ) {
                await this.loginAdmin();
                return;
            }

            await this.loginUser();
        },

        acceptCookieConsent() {
            Cookie.set( 'cookie_consent', 'true', { expires: 356,
                sameSite: 'Strict' } );
            this.cookieAccepted = true;
        },
    },
};
</script>
<style lang="scss">
  #forgot-details-text a {
      text-decoration: underline;
  }

  #login-form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);

    @media screen and (max-width: 575px) {
      height: 100vh;
    }
  }

  #language-picker {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border-radius: 50px;
    width: fit-content;
    margin: 0 auto;

    button {
      position: relative;
      color: #fff;
      font-weight: 500;

      &:hover,
      &.active {
        text-decoration: underline;
      }
    }
  }
</style>
